export type RoomId =
  | 'sensor-array'
  | 'bridge'
  | 'cargo-bay'
  | 'comms-deck'
  | 'storefront-bay'
  | 'design-studio';

export interface Room {
  id: RoomId;
  name: string;
  bot: string;
  // normalized 0..1 coordinates on the ship layout canvas
  x: number;
  y: number;
  w: number;
  h: number;
  accent: number; // hex color
}

export const ROOMS: Room[] = [
  {
    id: 'bridge',
    name: 'Bridge',
    bot: 'Navigator',
    x: 0.38, y: 0.04, w: 0.24, h: 0.18,
    accent: 0x22e4ff,
  },
  {
    id: 'sensor-array',
    name: 'Sensor Array',
    bot: 'Scout',
    x: 0.06, y: 0.27, w: 0.26, h: 0.22,
    accent: 0x5aff9f,
  },
  {
    id: 'cargo-bay',
    name: 'Cargo Bay',
    bot: 'Quartermaster',
    x: 0.68, y: 0.27, w: 0.26, h: 0.22,
    accent: 0xffb347,
  },
  {
    id: 'comms-deck',
    name: 'Comms Deck',
    bot: 'Comms',
    x: 0.38, y: 0.58, w: 0.24, h: 0.20,
    accent: 0xff4dd4,
  },
  {
    id: 'storefront-bay',
    name: 'Storefront Bay',
    bot: 'Curator',
    x: 0.06, y: 0.58, w: 0.26, h: 0.20,
    accent: 0x9b5cff,
  },
  {
    id: 'design-studio',
    name: 'Design Studio',
    bot: 'Designer',
    x: 0.68, y: 0.58, w: 0.26, h: 0.20,
    accent: 0xff6b35,
  },
];

// Corridor connections between room centers [fromId, toId]
export const CORRIDORS: [RoomId, RoomId][] = [
  ['bridge', 'sensor-array'],
  ['bridge', 'cargo-bay'],
  ['bridge', 'comms-deck'],
  ['sensor-array', 'storefront-bay'],
  ['cargo-bay', 'design-studio'],
  ['comms-deck', 'storefront-bay'],
  ['comms-deck', 'design-studio'],
];
